<template>
  <div
    @click="onChange"
    class="flex-start padding-right-6 padding-y-10 padding-left-5 item position-relative"
    :class="[active ? 'active' : '']"
  >
    <div v-show="active" class="conner top-conner position-absolute"></div>
    <img v-if="active" :src="selectedIcon" class="icon" />
    <img v-else :src="unselectedIcon" class="icon" />
    <span
      class="font-16 margin-left-5 name"
      :class="active ? 'font-weight color-main' : 'font-light title-color'"
      >{{ title }}</span
    >
    <div v-show="active" class="conner bottom-conner position-absolute"></div>
  </div>
</template>
<script >
import { onMounted } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.props = {
  url: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  selectedIcon: {
    type: String,
    default: ''
  },
  unselectedIcon: {
    type: String,
    default: ''
  },
  active: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emits = __ctx.emit;
  const onChange = () => {
    emits('click');
  };
  onMounted(() => {});
  return {
    onChange
  };
};
export default __sfc_main;
</script>
<style scoped lang="scss">
  .title-color {
    color: #778296;
  }
  .icon {
    width: 18px;
    height: 18px;
    margin-left: 5px;
  }
  $w: 20px;
  $h: 20px;
  $radius: 20px;
  .conner {
    background-color: #fff;
    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    width: $w;
    height: $h;
    right: 0;
    z-index: 2;
    &:after {
      content: '';
      position: absolute;
      background-color: #eef5ff;
      width: 100%;
      height: 100%;
      top: 0;
      right: 0;
      z-index: 2;
    }
  }
  .item {
    cursor: pointer;
    .name,
    .icon {
      transition: all 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);
    }
    &:hover {
      .name,
      .icon {
        transform: translateX(3px);
      }
    }
    &.active {
      background-color: #fff;
      border-radius: 14px 0 0 14px;
      box-shadow: 9px 0px 8px 0px rgba(0, 0, 0, 0.05);
      .top-conner {
        top: -$h;
        &:after {
          border-radius: 0 0 $radius 0;
        }
      }
      .bottom-conner {
        bottom: -$h;
        &:after {
          border-radius: 0 $radius 0 0;
        }
      }
    }
  }
</style>
